import { HotlineModalContent } from '@/components/modals/hotline-modal-content';
import { HotlineModal } from './hotline-modal';

export const HotlineModalWithCTA = () => (
  <HotlineModal>
    <HotlineModalContent />
  </HotlineModal>
);
